// extracted by mini-css-extract-plugin
export default {"container":"SortingCard_container__ZwkJW","idIn":"SortingCard_idIn__bUnU5","name":"SortingCard_name__DX+th"};